import type {
	addBonusInput,
	deleteBonusInput,
	getAllBonusInput,
	getBonusInput,
	updateBonusInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAllBonus: getAllBonusInput;
	useAddBonus: addBonusInput;
	useGetBonus: getBonusInput;
	useUpdateBonus: updateBonusInput;
	useDeleteBonus: deleteBonusInput;
}

const BONUS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>("bonus", [
	"useGetAllBonus",
	"useAddBonus",
	"useGetBonus",
	"useUpdateBonus",
	"useDeleteBonus",
]);

export { BONUS_SERVICE_KEYS };
